import { Button, TextField, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useRef, useState } from 'react';
import { EmbedControllerProps } from './types';

export const EmbedFromLink = ({
  createEmbed,
  onClose,
  options,
}: EmbedControllerProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isInvalid, setIsInvalid] = useState(false);

  const onSubmit = () => {
    const link = inputRef.current?.value;
    if (!link) return;

    if (!isValidLink(link)) {
      setIsInvalid(true);
      return;
    }

    createEmbed(link);
  };

  return (
    <Stack spacing={2} p={2}>
      <TextField
        inputRef={inputRef}
        label=""
        autoFocus
        variant="outlined"
        fullWidth
        size="small"
        error={isInvalid}
        helperText={isInvalid ? 'Invalid link' : ''}
        placeholder={options.ui.inputPlaceholder}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();

            onSubmit();
          }

          if (e.key === 'Escape') {
            onClose();
          }
        }}
      />
      <Button variant="contained" size="small" fullWidth onClick={onSubmit}>
        {options.ui.buttonLabel}
      </Button>

      <Typography variant="caption" color="text.secondary">
        any web link can be embedded (with or without https://)
      </Typography>
    </Stack>
  );
};

const isValidLink = (link: string): boolean => {
  const trimmedLink = link.trim();
  // (http:// ou https://)
  if (/^https?:\/\/[^\s]+/.test(trimmedLink)) {
    return true;
  }

  // starts with www.
  if (/^www\.[^\s]+/.test(trimmedLink)) {
    return true;
  }

  // valid domain
  if (
    /^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/.test(
      trimmedLink,
    )
  ) {
    return true;
  }

  return false;
};
